export const SUMMER_SCHOOL_VIDEO_ID = "qIQYAtbmMD4";

export const summerSchoolBar2026Content = {
  me: {
    breadcrumbHome: "Početna",
    breadcrumbCurrent: "Ljetnja škola Bar 2026",
    hero: {
      eyebrow: "FPEP Bar · jul 2026",
      title: "Ljetnja škola Bar 2026",
      subtitle: "Znanje koje izlazi iz učionice",
      lead:
        "Najveći vannastavni događaj u organizaciji FPEP Bar okupio je studente Hochschule Burgenland, predstavnike evropskih i crnogorskih institucija i prijatelje Fakulteta u višednevnom programu nastave, susreta, kulture i upoznavanja Crne Gore.",
      primaryCta: "Pogledajte video najavu",
      secondaryCta: "Pregled programa",
      facts: [
        { value: "Bar", label: "domaćin programa" },
        { value: "06. i 10. jul", label: "izdvojeni programski dani" },
        {
          type: "country-flags",
          value: "Austrija i Crna Gora",
          label: "partnerstvo kroz obrazovanje",
        },
      ],
    },
    intro: {
      eyebrow: "Međunarodna saradnja u praksi",
      title: "Tokom nekoliko julskih dana, nastava je izašla iz amfiteatra.",
      paragraphs: [
        "Summer School Bar 2026 osmišljena je kao susret akademskog rada i stvarnog okruženja. Nastava nije ostala zatvorena u amfiteatru: studenti su razgovarali sa predstavnicima institucija, upoznali poslovni i društveni kontekst Bara i povezali teme evropskih integracija, preduzetništva, održivog razvoja i jezika.",
        "FPEP Bar je bio organizator i domaćin programa, dok su studenti Hochschule Burgenland iz Austrije u Bar donijeli međunarodnu perspektivu i novu energiju. Otvaranju i programskim aktivnostima pridružili su se partneri i prijatelji iz Crne Gore i Evropske unije.",
      ],
      quote:
        "Cilj nije bio samo predstaviti Fakultet, već omogućiti studentima da Bar i Crnu Goru upoznaju kroz ljude, institucije, kulturu i svakodnevni život.",
    },
    pillars: {
      eyebrow: "Jedan program, više iskustava",
      title: "Časovi, posjete institucijama i upoznavanje Crne Gore bili su dio istog programa.",
      items: [
        {
          icon: "fa-language",
          title: "Jezici i komunikacija",
          text: "Časovi crnogorskog i ruskog jezika bili su dio svakodnevnog programa i prostor za neposrednu komunikaciju među studentima.",
        },
        {
          icon: "fa-landmark",
          title: "Institucije iz prve ruke",
          text: "Evropska kuća Bar, Luka Bar i BSC Bar otvorili su teme evropskih vrijednosti, strateške privrede, preduzetništva i održivog razvoja.",
        },
        {
          icon: "fa-users",
          title: "Ljudi prije protokola",
          text: "Program je građen oko razgovora, upoznavanja i zajedničkog rada, a ne samo formalnih prezentacija.",
        },
        {
          icon: "fa-compass",
          title: "Crna Gora kao učionica",
          text: "Obilasci Budve, Kotora i Cetinja povezali su akademski program sa istorijom, kulturom i savremenim životom zemlje domaćina.",
        },
      ],
    },
    video: {
      eyebrow: "Video najava",
      title: "Pogledajte kako je najavljen dolazak gostujućih studenata u Bar.",
      text:
        "Pogledajte najavu Summer School Bar Montenegro 2026 i atmosferu kojom je FPEP Bar otvorio program za gostujuće studente i partnere.",
      button: "Pokreni video",
      modalTitle: "Summer School Bar Montenegro 2026",
      close: "Zatvori video",
    },
    agenda: {
      eyebrow: "Program po satnici",
      title: "Program 6. i 10. jula, sat po sat.",
      intro:
        "Programi od 6. i 10. jula spojili su svečano otvaranje, akademske susrete i posjete institucijama. Satnice su prikazane u punom obimu.",
      days: [
        {
          date: "06. jul 2026.",
          label: "Svečano otvaranje",
          location: "FPEP Bar",
          mapUrl: "https://maps.app.goo.gl/8UWxepEJZMKKbpKa8",
          mapLabel: "Otvori lokaciju",
          summary:
            "Prvi dan bio je posvećen dobrodošlici, predstavljanju učesnika i nastavnika, uvodnim obraćanjima i upoznavanju sa Fakultetom.",
          items: [
            {
              time: "17:45–18:00",
              title: "Registracija učesnika",
              detail: "Prof.in(FH) Mag.a Ludmila Waschak",
            },
            {
              time: "18:00",
              title: "Otvaranje Ljetnje škole",
              detail: "Video dobrodošlice",
            },
            {
              time: "18:10–18:50",
              title: "Uvodna obraćanja",
              detail:
                "Prof.in (FH) Mag.a Dr.in Tonka Semmler-Matošić, rukovoditeljka osnovnih studija International Economic Relations na Hochschule Burgenland; Dejana Petranović, Local Public Space Manager, Evropska kuća Bar; Nj. E. dr Christian Steiner, ambasador Austrije u Crnoj Gori; dr Nikola Abramović, prodekan za međunarodnu saradnju FPEP Bar.",
            },
            {
              time: "18:50–19:00",
              title: "Pozdravno obraćanje na austrijskom njemačkom jeziku",
              detail:
                "Onlajn obraćanje prof. dr Đura Đurića, rukovodioca katedre za pravo na FPEP Bar i nekadašnjeg službenika Raiffeisen banke u Beču.",
            },
            {
              time: "19:00–19:15",
              title: "Upoznajte predavače",
              detail:
                "Ms. Kalač — crnogorski jezik; Ms. Loyko — ruski jezik",
            },
            {
              time: "19:15–19:30",
              title: "Obilazak Fakulteta i tehnička uputstva",
              detail: "Upoznavanje sa prostorom i organizacijom rada",
            },
            {
              time: "19:30",
              title: "Zatvaranje programa i networking",
              detail: "Neformalno upoznavanje učesnika i gostiju",
            },
          ],
        },
        {
          date: "10. jul 2026.",
          label: "Institucije i lokalna ekonomija",
          location: "Evropska kuća Bar i BSC Bar",
          mapUrl: "https://maps.app.goo.gl/BuG9qMmCnLumAM7R9",
          mapLabel: "Evropska kuća Bar",
          secondaryMapUrl: "https://maps.app.goo.gl/aVJZAYmYJvSUjxiW6",
          secondaryMapLabel: "BSC Bar",
          summary:
            "Peti dan aktivnosti približio je studentima evropske programe, strateški značaj Luke Bar i podršku mladom preduzetništvu.",
          items: [
            {
              time: "09:00",
              title: "Registracija",
              detail: "Evropska kuća Bar",
            },
            {
              time: "09:10–09:20",
              title: "Evropska unija u Crnoj Gori",
              detail: "Predstavljanje aktivnosti Evropske kuće Bar",
            },
            {
              time: "09:20–09:40",
              title: "Luka Bar — najvažnija morska kapija Crne Gore",
              detail:
                "Predstavljanje strateškog resursa Crne Gore; Aleksandar Slabiđoreski, izvršni direktor Luke Bar",
            },
            {
              time: "09:40–09:50",
              title: "Predstavljanje FPEP Bar",
              detail: "Nermin Škretović, saradnik u nastavi",
            },
            {
              time: "Nakon pauze",
              title: "Pješački obilazak do Biznis start-up centra Bar",
              detail:
                "Oko 15 minuta hoda i upoznavanje sa organizacijom BSC Bar",
            },
            {
              time: "10:20–11:20",
              title: "Mladi, preduzetništvo i održivi razvoj",
              detail:
                "Aktivnosti BSC Bar, veze sa Evropskom unijom i mogućnosti za mlade preduzetnike; prof. dr Ivana Tomašević, direktorica BSC Bar",
            },
            {
              time: "11:20",
              title: "Povratak na FPEP Bar",
              detail: "Nastavak programa i časova jezika",
            },
          ],
        },
      ],
    },
    culture: {
      eyebrow: "Dobrodošlica koja se pamti",
      title: "Crnogorske igre ispred Fakulteta, zatim Budva, Kotor i Cetinje.",
      paragraphs: [
        "Svečano otvaranje nije završeno posljednjim govorom. Folklorno društvo iz Bara predstavilo je gostima tradicionalne crnogorske igre, pretvarajući prostor ispred Fakulteta u mjesto susreta dvije kulture.",
        "U narednim danima studenti su, uz redovnu nastavu, obilazili Budvu, Kotor i Cetinje. Boravak u Crnoj Gori obuhvatio je i 13. jul — Dan državnosti, datum koji povezuje međunarodno priznanje Crne Gore na Berlinskom kongresu 1878. godine i početak ustanka protiv fašizma 1941. godine.",
      ],
      cities: ["Budva", "Kotor", "Cetinje"],
      statehoodLabel: "13. jul",
      statehoodText: "Dan državnosti Crne Gore",
    },
    partners: {
      eyebrow: "Partneri i prijatelji programa",
      title: "FPEP Bar je organizovao program uz podršku institucija i partnera.",
      intro:
        "FPEP Bar je organizator i domaćin Summer School Bar 2026. Program su svojim učešćem, znanjem i podrškom oblikovali studenti Hochschule Burgenland i predstavnici institucija iz Crne Gore, Austrije i Evropske unije.",
      items: [
        { name: "FPEP Bar", role: "Organizator i domaćin" },
        {
          name: "Hochschule Burgenland",
          role: "Partnerska ustanova i gostujući studenti",
        },
        { name: "Evropska unija", role: "Evropski okvir i podrška" },
        { name: "Evropska kuća Bar", role: "Programski partner" },
        {
          name: "Ambasada Austrije u Crnoj Gori",
          role: "Institucionalna podrška",
        },
        { name: "Luka Bar", role: "Strateška privreda u praksi" },
        {
          name: "BSC Bar",
          role: "Preduzetništvo i održivi razvoj",
        },
        {
          name: "Partneri iz Danske i Rumunije",
          role: "Gosti i buduća saradnja",
        },
      ],
    },
    future: {
      eyebrow: "Pogled ka 2027. godini",
      title: "Interesovanje partnera već otvara prostor za naredno izdanje.",
      text:
        "Tokom programa FPEP Bar ugostio je i predstavnike partnerskih ustanova iz Danske i Rumunije, koji su iskazali interesovanje za slične aktivnosti naredne godine. Time Summer School Bar dobija potencijal da postane redovno mjesto susreta studenata i institucija iz više evropskih zemalja.",
      euText:
        "Program je ujedno bio prilika da FPEP Bar, Bar i Crna Gora pokažu kako evropska saradnja izgleda kada se pretvori u konkretan studentski doživljaj — u duhu inicijative 28 by 28.",
      linkLabel: "Saznajte više o 28 by 28",
      linkUrl: "https://28by28.eu/",
    },
    gallery: {
      eyebrow: "Fotografije programa",
      title: "Trenuci sa otvaranja i institucionalnih posjeta.",
      open: "Otvori fotografiju",
      close: "Zatvori galeriju",
      previous: "Prethodna fotografija",
      next: "Sljedeća fotografija",
      captions: [
        "Otvaranje Summer School Bar 2026 na FPEP Bar",
        "Učesnici programa tokom uvodnih aktivnosti",
        "Tim i prijatelji događaja",
        "Crnogorske tradicionalne igre ispred Fakulteta",
        "Kulturni program i susret sa gostujućim studentima",
        "Predstavljanje strateškog značaja Luke Bar",
        "Studenti tokom institucionalne posjete",
        "Predstavljanje aktivnosti Evropske kuće Bar",
      ],
    },
    cta: {
      eyebrow: "Ostanite povezani sa FPEP Bar",
      title: "Pratite naredne međunarodne prilike i priče sa Fakulteta.",
      text:
        "Konkursi, mobilnosti, novosti i fotografije objavljuju se tokom cijele godine. Izaberite kanal koji vam najviše odgovara.",
      links: {
        erasmus: "Erasmus+ stranica",
        calls: "Aktuelni konkursi",
        news: "Novosti",
        gallery: "Galerija",
        social: "Društvene mreže",
      },
    },
  },
  en: {
    breadcrumbHome: "Home",
    breadcrumbCurrent: "Summer School Bar 2026",
    hero: {
      eyebrow: "FPEP Bar · July 2026",
      title: "Summer School Bar 2026",
      subtitle: "Learning beyond the classroom",
      lead:
        "The largest extracurricular event organised by FPEP Bar brought students from the University of Applied Sciences Burgenland together with European and Montenegrin institutions and friends of the Faculty for several days of classes, meetings, culture and discovery of Montenegro.",
      primaryCta: "Watch the announcement",
      secondaryCta: "Explore the programme",
      facts: [
        { value: "Bar", label: "programme host city" },
        { value: "6 & 10 July", label: "featured programme days" },
        {
          type: "country-flags",
          value: "Austria and Montenegro",
          label: "partnership through education",
        },
      ],
    },
    intro: {
      eyebrow: "International cooperation in practice",
      title: "For several days in July, learning moved beyond the lecture hall.",
      paragraphs: [
        "Summer School Bar 2026 was designed as a meeting point between academic work and the real world. Learning did not remain inside the lecture hall: students spoke with institutional representatives, explored the economic and social context of Bar, and connected European integration, entrepreneurship, sustainable development and language learning.",
        "FPEP Bar organised and hosted the programme, while students from the University of Applied Sciences Burgenland brought an international perspective and fresh energy to the city. Partners and friends from Montenegro and the European Union joined the opening and programme activities.",
      ],
      quote:
        "The aim was not simply to present the Faculty, but to let students discover Bar and Montenegro through people, institutions, culture and everyday life.",
    },
    pillars: {
      eyebrow: "One programme, many experiences",
      title: "Classes, institutional visits and discovering Montenegro were part of the same programme.",
      items: [
        {
          icon: "fa-language",
          title: "Languages and communication",
          text: "Montenegrin and Russian language classes were part of the daily programme and created space for direct communication among students.",
        },
        {
          icon: "fa-landmark",
          title: "Institutions first-hand",
          text: "Europe House Bar, Port of Bar and BSC Bar opened discussions on European values, strategic industries, entrepreneurship and sustainable development.",
        },
        {
          icon: "fa-users",
          title: "People before protocol",
          text: "The programme was built around conversation, introductions and shared work, rather than formal presentations alone.",
        },
        {
          icon: "fa-compass",
          title: "Montenegro as a classroom",
          text: "Visits to Budva, Kotor and Cetinje connected the academic programme with the history, culture and contemporary life of the host country.",
        },
      ],
    },
    video: {
      eyebrow: "Video announcement",
      title: "See how the arrival of visiting students in Bar was announced.",
      text:
        "Watch the Summer School Bar Montenegro 2026 announcement and the atmosphere with which FPEP Bar welcomed visiting students and partners.",
      button: "Play video",
      modalTitle: "Summer School Bar Montenegro 2026",
      close: "Close video",
    },
    agenda: {
      eyebrow: "Programme timeline",
      title: "The programmes of 6 and 10 July, hour by hour.",
      intro:
        "The programmes held on 6 and 10 July combined the formal opening, academic encounters and institutional visits. Both schedules are presented in full.",
      days: [
        {
          date: "6 July 2026",
          label: "Opening day",
          location: "FPEP Bar",
          mapUrl: "https://maps.app.goo.gl/8UWxepEJZMKKbpKa8",
          mapLabel: "Open location",
          summary:
            "The first day focused on welcoming participants, introducing speakers and teachers, and presenting the Faculty.",
          items: [
            {
              time: "17:45–18:00",
              title: "Registration of participants",
              detail: "Prof.in(FH) Mag.a Ludmila Waschak",
            },
            {
              time: "18:00",
              title: "Opening of the Summer School",
              detail: "Welcoming video",
            },
            {
              time: "18:10–18:50",
              title: "Introduction addresses",
              detail:
                "Prof.in (FH) Mag.a Dr.in Tonka Semmler-Matošić, Head of the Bachelor's programme in International Economic Relations at the University of Applied Sciences Burgenland; Dejana Petranović, Local Public Space Manager, Europe House Bar; H.E. Dr Christian Steiner, Ambassador of Austria to Montenegro; Dr Nikola Abramović, Vice-Dean for International Cooperation at FPEP Bar.",
            },
            {
              time: "18:50–19:00",
              title: "Welcome remarks in Austrian German",
              detail:
                "Online address by Prof. Dr Đuro Đurić, Head of the Law Department at FPEP Bar and a former Raiffeisen Bank official in Vienna.",
            },
            {
              time: "19:00–19:15",
              title: "Meet the teachers",
              detail:
                "Ms Kalač — Montenegrin language; Ms Loyko — Russian language",
            },
            {
              time: "19:15–19:30",
              title: "Campus tour and technical instructions",
              detail: "Introduction to the facilities and programme organisation",
            },
            {
              time: "19:30",
              title: "Closing and networking",
              detail: "Informal introductions among participants and guests",
            },
          ],
        },
        {
          date: "10 July 2026",
          label: "Institutions and the local economy",
          location: "Europe House Bar and BSC Bar",
          mapUrl: "https://maps.app.goo.gl/BuG9qMmCnLumAM7R9",
          mapLabel: "Europe House Bar",
          secondaryMapUrl: "https://maps.app.goo.gl/aVJZAYmYJvSUjxiW6",
          secondaryMapLabel: "BSC Bar",
          summary:
            "The fifth day introduced students to European programmes, the strategic importance of the Port of Bar and support available to young entrepreneurs.",
          items: [
            {
              time: "09:00",
              title: "Registration",
              detail: "Europe House Bar",
            },
            {
              time: "09:10–09:20",
              title: "The European Union in Montenegro",
              detail: "Presentation of the activities of Europe House Bar",
            },
            {
              time: "09:20–09:40",
              title: "Port of Bar — Montenegro's principal sea gateway",
              detail:
                "Presentation of a strategic national resource by Aleksandar Slabiđoreski, Executive Director of the Port of Bar",
            },
            {
              time: "09:40–09:50",
              title: "Introducing FPEP Bar",
              detail: "Nermin Škretović, Teaching Assistant",
            },
            {
              time: "After the break",
              title: "Walking tour to Business Start-up Center Bar",
              detail:
                "Approximately 15 minutes on foot and an introduction to the organisation of BSC Bar",
            },
            {
              time: "10:20–11:20",
              title: "Young people, entrepreneurship and sustainable development",
              detail:
                "BSC Bar activities, links with the European Union and opportunities for young entrepreneurs; Prof. Dr Ivana Tomašević, Director of BSC Bar",
            },
            {
              time: "11:20",
              title: "Return to FPEP Bar",
              detail: "Continuation of the programme and language classes",
            },
          ],
        },
      ],
    },
    culture: {
      eyebrow: "A welcome to remember",
      title: "Montenegrin dances outside the Faculty, followed by Budva, Kotor and Cetinje.",
      paragraphs: [
        "The formal opening did not end with the final speech. A folklore ensemble from Bar introduced guests to traditional Montenegrin dances, turning the area in front of the Faculty into a meeting place for two cultures.",
        "In the following days, alongside scheduled classes, students visited Budva, Kotor and Cetinje. Their stay also included 13 July — Montenegro's Statehood Day, which links the country's international recognition at the Congress of Berlin in 1878 with the beginning of the anti-fascist uprising in 1941.",
      ],
      cities: ["Budva", "Kotor", "Cetinje"],
      statehoodLabel: "13 July",
      statehoodText: "Montenegro's Statehood Day",
    },
    partners: {
      eyebrow: "Partners and friends of the programme",
      title: "FPEP Bar organised the programme with the support of institutions and partners.",
      intro:
        "FPEP Bar organised and hosted Summer School Bar 2026. Students from the University of Applied Sciences Burgenland and representatives of institutions from Montenegro, Austria and the European Union shaped the programme through their participation, expertise and support.",
      items: [
        { name: "FPEP Bar", role: "Organiser and host" },
        {
          name: "University of Applied Sciences Burgenland",
          role: "Partner institution and visiting students",
        },
        { name: "European Union", role: "European framework and support" },
        { name: "Europe House Bar", role: "Programme partner" },
        {
          name: "Embassy of Austria in Montenegro",
          role: "Institutional support",
        },
        { name: "Port of Bar", role: "Strategic economy in practice" },
        {
          name: "BSC Bar",
          role: "Entrepreneurship and sustainable development",
        },
        {
          name: "Partners from Denmark and Romania",
          role: "Guests and future cooperation",
        },
      ],
    },
    future: {
      eyebrow: "Looking towards 2027",
      title: "Partner interest already creates room for the next edition.",
      text:
        "During the programme, FPEP Bar also welcomed representatives of partner institutions from Denmark and Romania, who expressed interest in organising similar activities in the following year. Summer School Bar therefore has the potential to become a regular meeting point for students and institutions from several European countries.",
      euText:
        "The programme also allowed FPEP Bar, the city of Bar and Montenegro to show what European cooperation looks like when it becomes a tangible student experience — in the spirit of the 28 by 28 initiative.",
      linkLabel: "Learn more about 28 by 28",
      linkUrl: "https://28by28.eu/",
    },
    gallery: {
      eyebrow: "Programme photographs",
      title: "Moments from the opening and institutional visits.",
      open: "Open photograph",
      close: "Close gallery",
      previous: "Previous photograph",
      next: "Next photograph",
      captions: [
        "Opening of Summer School Bar 2026 at FPEP Bar",
        "Programme participants during the opening activities",
        "The team and friends of the event",
        "Traditional Montenegrin dances outside the Faculty",
        "Cultural programme and visiting students",
        "Presentation of the strategic importance of the Port of Bar",
        "Students during an institutional visit",
        "Presentation of Europe House Bar activities",
      ],
    },
    cta: {
      eyebrow: "Stay connected with FPEP Bar",
      title: "Follow the next international opportunities and stories from the Faculty.",
      text:
        "Calls, mobility opportunities, news and photographs are published throughout the year. Choose the channel that works best for you.",
      links: {
        erasmus: "Erasmus+ page",
        calls: "Current calls",
        news: "News",
        gallery: "Gallery",
        social: "Social media",
      },
    },
  },
};

export function getSummerSchoolBar2026Content(language = "me") {
  return String(language || "me").toLowerCase().startsWith("en")
    ? summerSchoolBar2026Content.en
    : summerSchoolBar2026Content.me;
}
